import useAPI from '@/hooks/useAPI';
import SecretRepository from '@/repositories/SecretRepository';
import { SecretParams } from '@/types/secrets';

const useSecret = ({
  decrypt,
  enabled = true,
  params
}: {
  decrypt: boolean;
  enabled?: boolean;
  params: SecretParams;
}) => {
  const secretRepository = SecretRepository();

  return useAPI({
    queryKey: ['getSecret', decrypt, params],
    queryFn: () => secretRepository.getSecret({ decrypt, params }),
    enabled
  });
};

export default useSecret;
